import { useQuery } from "react-query"
import { request } from "../util/request"
import { getPreviewTokenFromUrl } from "../util/previewToken"

export function usePost(postId, fields, options = {}) {
  const previewToken = options.previewToken ?? getPreviewTokenFromUrl()
  return useQuery(["post", postId, fields, previewToken], getPostById, {
    retry: false,
    enabled: options.enabled ?? true,
  })
}

const getPostById = async ({ queryKey }) => {
  const [key, id, fields, previewToken] = [...queryKey]
  return await request({
    queryKey: [
      key,
      {
        path: `/api/v1/posts/${id}.json`,
        params: { fields: fields, preview_token: previewToken },
      },
    ],
  })
}
